import { useState } from "react"

export const ProductState = () => {    const [isLoader, setIsLoader] = useState(false)
    const [viewLoader, setViewLoader] = useState(false)
    const [orderlist, setOrderList] = useState([])
    const [action, setAction] = useState([])
    const [isConfirm, setIsConfirm] = useState(false)
    const [search, setSearch] = useState('')
    const [inftSrcoll, setInftScroll] = useState(false)
    const [lid, setLid] = useState(0)
    const [driverInfo, setDriverInfo] = useState({name: '', contact_no: '', remarks:''})
    const [msg, setMsg] = useState('')
    const [err, setErr] = useState(false)
    const [payBalForm, setPayBalForm] = useState({modal: false, mode_payment: '', payment_channel: '', bal_payment: '', payment_ref: '', btnLoader: false, confirmation: false, error: false})
    const [payChannel, setPayChannel] = useState([])
    return {
          isLoader: { data: isLoader, set: setIsLoader },
        viewLoader: { data: viewLoader, set: setViewLoader },
        orderlist: { data: orderlist, set: setOrderList },
        action: { data: action, set: setAction },
        isConfirm: { data: isConfirm, set: setIsConfirm },
        search: { data: search, set: setSearch },
        inftSrcoll: { data: inftSrcoll, set: setInftScroll },
        lid: { data: lid, set: setLid },
        driverInfo: { data: driverInfo, set: setDriverInfo },
        msg: { data: msg, set: setMsg },
        err: { data: err, set: setErr },
        payBalForm: { data: payBalForm, set: setPayBalForm },
        payChannel: { data: payChannel, set: setPayChannel },
    }
}
